import api from "../../services/api";
import toastError from "../../errors/toastError";

const useLeads = () => {
  const findAll = async () => {
    try {
      const { data } = await api.get("/leads");
      return data;
    } catch (err) {
      toastError(err);
    }
  };

  const save = async (leadData) => {
    try {
      const { data } = await api.post("/leads", leadData);
      return data;
    } catch (err) {
      toastError(err);
    }
  };

  const update = async (leadData) => {
    try {
      const { data } = await api.put(`/leads/${leadData.id}`, leadData);
      return data;
    } catch (err) {
      toastError(err);
    }
  };

  const deleteLead = async (id) => {
    try {
      const { data } = await api.delete(`/leads/${id}`);
      return data;
    } catch (err) {
      toastError(err);
    }
  };

  return {
    findAll,
    save,
    update,
    deleteLead,
  };
};

export default useLeads;
